import React from 'react'

const DialogTips = ({ data = [] }) => {
    return (
        <div>
            {data.map((item, index) => (
                <div className="sub-doc" key={index}>
                    {item}
                </div>
            ))}
        </div>
    )
}

export default DialogTips
